var _circle, _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotFoundPageImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 445,
    height: 445,
    viewBox: "0 0 445 445",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 222.5,
    r: 222.5,
    fill: "url(#paint0_radial_445_49287)",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.583 312.5C168 308.664 161.001 287.5 164.581 278.305C163.817 287.573 166.555 298.856 175.582 303.305C186.866 308.866 192.082 309.305 202.082 309.305H243.582C245.394 309.305 277.069 312.093 277.582 285.805C278.095 259.517 281 251.141 298.48 216.089C314.082 184.805 314.152 182.805 325.152 159.305C327.727 153.805 333.479 145.805 326.581 105.805C325.374 98.8047 321.275 88.0376 319.581 84.8047C312.985 72.2131 309.15 67.7519 301.582 53.3047C305.082 55.8047 311.582 62.1698 322.828 82.1205C327.957 91.2202 338.239 134.627 334.082 147.305C324.081 177.805 312.001 204 302.001 224C289.309 249.384 284.001 267.5 282.001 290.5C280.001 313.5 273.001 311 265.501 312.5C258.001 314 255.54 314.055 249.501 314.5C246.743 314.811 238.87 314.898 236.492 314.979C236.282 314.987 236.116 314.994 236.001 315C224.488 315.582 217.001 315 203.001 315C193.987 315 182.501 316 175.583 312.5Z",
    fill: "#01924F",
    fillOpacity: 0.17
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M209.078 230.305C209.478 228.305 193.245 175.138 185.078 148.805C190.245 147.971 201.078 145.205 203.078 140.805C209.911 149.638 227.478 161.505 243.078 138.305C244.245 143.138 250.078 152.005 264.078 148.805L235.078 230.305M209.078 230.305C208.678 232.305 206.578 271.471 205.578 290.805M209.078 230.305C218.078 230.305 218.078 223.305 219.078 210.805C219.878 200.805 215.745 192.305 213.578 189.305C205.078 175.805 203.078 140.805 203.078 135.805M235.078 230.305L239.078 290.805M235.078 230.305C227.078 230.305 227.578 225.805 226.078 210.805C224.878 198.805 228.578 191.471 230.578 189.305C236.578 180.905 241.411 150.138 243.078 135.805M264.078 175.305L265.078 181.805H267.578V200.305M267.578 200.305C268.245 200.138 269.978 200.105 271.578 201.305C273.578 202.805 273.578 204.305 276.078 204.305M267.578 200.305V204.305L269.578 204.805L267.578 212.805",
    stroke: "url(#paint1_linear_445_49287)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M180.58 329.306C180.58 333.306 183.913 337.639 185.58 339.306C183.913 340.306 180.58 343.306 180.58 347.306C180.58 351.306 184.247 354.806 186.58 356.306C184.247 356.639 180.58 359.206 180.58 364.806C180.58 370.406 183.913 373.139 185.58 373.806H263.58C265.58 372.639 269.58 369.206 269.58 364.806C269.58 360.406 265.58 357.806 263.58 356.306C265.58 355.306 269.58 350.906 269.58 347.306C269.58 343.706 266.58 340.473 264.58 339.306C266.58 337.973 269.58 334.106 269.58 329.306C269.58 324.506 264.58 322.306 262.08 321.806H185.58C183.913 322.639 180.58 325.306 180.58 329.306Z",
    fill: "url(#paint2_linear_445_49287)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M253 383.001H198C204.4 391.401 212.42 395.697 217.5 396.501H230.5C240.42 396.697 249.167 387.501 253 383.001Z",
    fill: "url(#paint3_linear_445_49287)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M176.58 311.306C173.247 308.973 166.28 302.507 165.08 295.307C163.58 286.307 165.08 269.807 161.08 258.307C157.08 246.807 140.08 212.307 131.58 198.807C123.08 185.307 114.58 168.806 113.08 152.306C111.58 135.806 112.08 135.306 112.08 134.306C112.08 133.306 127.58 136.806 135.08 145.806C141.08 153.006 147.913 170.139 150.58 177.805C155.413 175.805 166.68 172.405 173.08 174.805C179.48 177.205 182.413 177.805 183.08 177.805M183.08 177.805C183.08 174.639 183.08 168.205 183.08 167.805C183.08 167.405 208.413 155.972 221.08 150.305L229.58 117.305L262.58 89.3052L283.08 122.305L310.58 100.805M300.58 223.306C311.747 202.306 331.5 173.001 334.58 142.306C336.378 124.389 333 109 328.08 96.3052C320.98 77.986 300.58 49.8052 301.08 53.3052C301.48 56.1052 307.58 86.1386 310.58 100.805V125.806C309.747 128.473 305.58 134.306 295.58 136.306C285.58 138.306 269.413 162.805 262.58 174.805L227.08 177.805L206.08 214.306L194.58 202.306C194.58 195.473 193.98 181.407 191.58 179.806C189.18 178.205 184.913 177.805 183.08 177.805M280.58 295.307C280.58 298.973 279.38 306.806 274.58 308.806C269.78 310.806 264.58 311.306 262.58 311.306M202.5 313.501L225 314.001L249 313.001M185.58 339.306C183.913 337.639 180.58 333.306 180.58 329.306C180.58 325.306 183.913 322.639 185.58 321.806H262.08C264.58 322.306 269.58 324.506 269.58 329.306C269.58 334.106 266.58 337.973 264.58 339.306C266.58 340.473 269.58 343.706 269.58 347.306C269.58 350.906 265.58 355.306 263.58 356.306C265.58 357.806 269.58 360.406 269.58 364.806C269.58 369.206 265.58 372.639 263.58 373.806H185.58C183.913 373.139 180.58 370.406 180.58 364.806C180.58 359.206 184.247 356.639 186.58 356.306C184.247 354.806 180.58 351.306 180.58 347.306C180.58 343.306 183.913 340.306 185.58 339.306ZM198 383.001H253C249.167 387.501 240.42 396.697 230.5 396.501H217.5C212.42 395.697 204.4 391.401 198 383.001Z",
    stroke: "url(#paint4_linear_445_49287)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 190.578,
    y: 333.305,
    width: 67,
    height: 8,
    rx: 4,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M192.578 356.305C192.578 354.096 194.369 352.305 196.578 352.305H234.578C236.787 352.305 238.578 354.096 238.578 356.305C238.578 358.514 236.787 360.305 234.578 360.305H196.578C194.369 360.305 192.578 358.514 192.578 356.305Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M188.5 159.5L191.5 169.5M204.5 154L205.5 161.5M214.5 150C216.667 151.167 221.6 152.7 226 151.5",
    stroke: "#B6B6B6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_445_49287",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(129 29.5) rotate(58.7917) scale(441.956)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#018D47",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#018D47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_445_49287",
    x1: 203.578,
    y1: 139.305,
    x2: 230.578,
    y2: 290.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_445_49287",
    x1: 291.08,
    y1: 346.297,
    x2: 268.86,
    y2: 390.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_445_49287",
    x1: 291.08,
    y1: 346.297,
    x2: 268.86,
    y2: 390.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_445_49287",
    x1: 275.58,
    y1: 317.797,
    x2: 221.096,
    y2: 290.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01924F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundPageImage);
export default __webpack_public_path__ + "static/media/not-found-page-image.b3ea706c7256ea79f41f56580268c1ef.svg";
export { ForwardRef as ReactComponent };